import _ from 'lodash';
import { format as dateFnsFormat } from 'date-fns';

export function formatDate(date?: Date) {
    return date ? dateFnsFormat(date, "yyyy-MM-dd") : "";
}

export function formatTime(date?: Date) {
    return date ? dateFnsFormat(date, "HH:mm") : "";
}

export function formatDateTime(date?: Date) {
    return date ? dateFnsFormat(date, "yyyy-MM-dd HH:mm") : "";
}

export function formatYesNo(val?: boolean|null) {
    if (val == null) {
        return '';
    }
    return val ? 'Ja' : 'Nej';
};

export function formatYesEmpty(val?: boolean|null) {
    return val ? 'Ja' : '';
};
